document.addEventListener('DOMContentLoaded', () => {
  const lottie = document.getElementById('site-logo-lottie');
  if (!lottie) return;

  let isAtTop = true;
  let isReady = false;

  lottie.addEventListener('ready', () => {
    isReady = true;
    lottie.seek(0);
  });

  function checkScrollState() {
    if (!isReady) return;

    const scrolled = window.scrollY > 0;

    if (scrolled && isAtTop) {
      isAtTop = false;
      lottie.setDirection(1);
      lottie.play();
    } else if (!scrolled && !isAtTop) {
      isAtTop = true;
      lottie.setDirection(-1);
      lottie.play();
    }
  }

  window.addEventListener('scroll', checkScrollState, { passive: true });
});
